import { formatDateToBR } from "../../../../../utils/time";
import { SETableColumnsProps } from "../../../../components/SETable";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiDeleteBin2Fill,
  RiEdit2Fill,
  RiErrorWarningFill,
} from "react-icons/ri";
import React from "react";
import {formatStringArray} from "../../../../utils/utils";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "dataCriacao",
    label: "Data",
    width: 50,
    customField: formatDateToBR,
    align: "center",
  },
  {
    id: "uf",
    label: "UF",
    customField: (uf: any) => uf?.sigla,
    align: "center",
  },
  {
    id: "nome",
    label: "Nome",
    align: "center",
  },
  {
    id: "tema",
    label: "Tema",
    customField: (tema: any) => tema?.descricao,
  },
  {
    id: "obrigatoriedade",
    label: "Obrigatoriedade",
  },
  {
    id: "tipoAtendente",
    label: "Perfil Atendente",
    customField: formatStringArray
  },
  {
    id: "arquivo",
    label: "Arquivo",
    customField: (file: any) => (
      <IconButton
        href={file?.urlConteudo}
        target="_blank"
        rel="noopener noreferrer"
      >
        {['PDF', 'pdf', 'application/pdf', 'file/pdf']?.includes(file?.extensao) ? (
          <Box display="flex" gap={2}>
            <Typography>PDF</Typography>
            <img src={require("./pdf.svg")} alt="" />
          </Box>
        ) : (
          <Box display="flex" gap={2}>
            <Typography>XLS</Typography>
            <img src={require("./xls.svg")} alt="" />
          </Box>
        )}
      </IconButton>
    ),
  },
  {
    id: "status",
    label: "Status",
    width: 250,
    align: "center",
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} alignItems="center" justifyContent="center">
          <IconButton onClick={() => handleUpdateStatus(row)}>
            <>
              {value === "APROVADO" && (
                <RiCheckboxCircleFill size={20} color="#66BD91" />
              )}
              {value === "PENDENTE" && (
                <RiErrorWarningFill size={20} color="#F6E566" />
              )}
              {value === "REPROVADO" && (
                <RiCloseCircleFill size={20} color="#FF0000" />
              )}
            </>
          </IconButton>
          <IconButton onClick={() => handleEdit(row)}>
            <RiEdit2Fill size={20} color="#007bff" />
          </IconButton>
          <IconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin2Fill size={20} color="#ff4d4f" />
          </IconButton>
        </Grid>
      </Grid>
    ),
  },
];
